import { render } from "./ButtonForIcon.vue?vue&type=template&id=09a80111"
import script from "./ButtonForIcon.vue?vue&type=script&lang=js"
export * from "./ButtonForIcon.vue?vue&type=script&lang=js"

import "./ButtonForIcon.vue?vue&type=style&index=0&id=09a80111&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__